export default __webpack_public_path__ + "static/media/wiki-olympus-mobile.9ebea008.jpg";